import { render, staticRenderFns } from "./Service_Gallery.vue?vue&type=template&id=6880a1ec&scoped=true&"
import script from "./Service_Gallery.vue?vue&type=script&lang=js&"
export * from "./Service_Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Service_Gallery.vue?vue&type=style&index=0&id=6880a1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6880a1ec",
  null
  
)

export default component.exports